export const VERSIONING_AUTH_SIGN_IN_PATH = '/auth/sign-in';

export const VERSIONING_EXTERNAL_AUTH_CALLBACK_PATH = '/auth/external/callback';

export const VERSIONING_RETURN_URL_QUERY_PARAM = 'returnUrl';
